import React from "react";
import PropTypes from "prop-types";
import "./readOnlyView.scss";

const ReadOnlyView = props => {
    const { className, label, value } = props;
    return (
        <div className={`padding-t-30 ${className}`}>
            <div className="label-block font-12">{label}</div>
            <div className="value-block font-14 fw-500">{value}</div>
        </div>
    );
};

ReadOnlyView.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    className: PropTypes.string
};

ReadOnlyView.defaultProps = {
    label: "",
    value: "",
    className: ""
};

export default ReadOnlyView;
